import { css as emotionCss } from "@emotion/css";
import { keyframes as emotionKeyframes } from "@emotion/css";
import { injectGlobal as emotionInjectGlobal } from "@emotion/css";

declare const IS_SERVER: boolean;

/**
 * Emotion has issues with having nested classnames if
 * those classnames are in the dynamic part of the template
 * string. This is a wrapper around @emotion/css to aleviate
 * these issues by putting everything in its static part.
 * This approach will probably break if we actually want some
 * dynamic css - however I am perfectly happy without it
 */
export const wrapCssInput =
	<T extends typeof emotionCss | typeof emotionKeyframes>(fn: T) =>
	(template: TemplateStringsArray, ...args: Array<unknown>) => {
		let myString = "";
		let myRawString = "";
		for (let i = 0; i < template.length; i++) {
			myString += template[i];
			myRawString += template.raw[i];
			if (i < args.length) {
				myString += args[i];
				myRawString += args[i];
			}
		}
		// @ts-ignore
		const newTemplate: Array<string> & { raw: string } = [myString];
		newTemplate.raw = myRawString;
		return fn(newTemplate);
	};

const injectGlobalWrapper = (
	...args: Parameters<typeof emotionInjectGlobal>
) => {
	if (IS_SERVER) {
		return emotionInjectGlobal(...args);
	}
};

export const css = wrapCssInput(emotionCss);

export const keyframes = wrapCssInput(emotionKeyframes);

export const injectGlobal = injectGlobalWrapper;
